//REV-21363 — types of the shared upload modal (Pure View).
//
//ONE component for both entry points (ADR-0009 §11): the hub's `Upload` button (multi-file) and
//the account area's upload control (`[multiple]=false`). The only difference is that input, so it
//is one component with an input — not two components.

/**
 * Why a picked file will NOT be sent. Exactly two reasons, both decidable locally — do not invent
 * a third: anything the client cannot decide belongs to the server's answer, not to this list.
 *
 * `type` — not `application/pdf`. Ingest is PDF-only (ADR-0009 §12).
 * `size` — over `maxSizeBytes` (32 MB, the existing upload route's cap).
 */
export type UploadRejectionReason = 'type' | 'size';

/**
 * A file the user picked that is shown as REJECTED and excluded from the emission, while the
 * accepted files stay selected. Rejecting the whole selection because one file was wrong would
 * make the user redo work the component already did correctly.
 */
export interface RejectedUpload {
    filename: string;
    size: number;
    reason: UploadRejectionReason;
}

/**
 * A failure the CONTAINER reports back per file — ADR-0009 §11's "Teilfehler" state. Distinct from
 * `RejectedUpload`: that one never left the browser, this one was sent and came back failed.
 */
export interface UploadFailure {
    filename: string;
    message: string;
}
